import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classnames from 'classnames';
import styles from './animate.scss';
export class Animate extends React.Component {
  render() {
    const {
      type = 'fade-in',
      children,
      when,
      className,
      activeClassName = '',
      dataHook
    } = this.props;
    if (!children) {
      return null;
    }
    const classNames = classnames(className, {
      [activeClassName]: when
    }, styles[type], {
      [styles.active]: when
    });
    return /*#__PURE__*/React.createElement("div", _extends({}, dataHook && when && {
      'data-hook': dataHook
    }, {
      className: classNames,
      "aria-hidden": !when
    }), children);
  }
}
//# sourceMappingURL=animate.js.map